/* global Search, searchInsightsListingData, searchInsightsListingRaw */

if (document.querySelector(".fbjs-search--insights-listing")) {
    let hasActiveFilters;
    // window.x = [] // for debug funnelback data
    window.searchInsightsListingRaw = [];
    window.searchInsightsListingData = {
        aditionalInfo: {
            resetData: 1,
        },
        viewpoint: null,
        article: null,
        podcast: null,
        blog: null,
        report: null,
    };

    const sortData = () => {
        searchInsightsListingData.viewpoint = searchInsightsListingRaw.filter(
            (el) => el.pageType === "Insight - Viewpoint"
        );

        searchInsightsListingData.article = searchInsightsListingRaw.filter(
            (el) => el.pageType === "Insight - Article"
        );

        searchInsightsListingData.podcast = searchInsightsListingRaw.filter(
            (el) => el.pageType === "Insight - Podcast"
        );

        searchInsightsListingData.blog = searchInsightsListingRaw.filter(
            (el) => el.pageType === "Insight - Blog"
        );

        searchInsightsListingData.report = searchInsightsListingRaw.filter(
            (el) => el.pageType === "Insight - Report"
        );
    };

    const buildHtml = async () => {
        let output =
            '<div class="results-wrapper--az cards-story cards-story--redesign">';

        /**
         * @param {string} clickTrackingUrl - url to item
         * @param {string} title  - title of item
         * @param {string} pageType  - type of item
         * @param {string} img  - img of item
         * @returns {html}
         */
        const boxTemplate = (
            clickTrackingUrl,
            title,
            pageType,
            img,
            url,
            marks,
            date,
            description
        ) => {
            // const webinarOverlay = () => {
            //     if (pageType === "Event - Webinar") {
            //         return `<article class="cards__card--hover cards__card row no-gutters flex-wrap">
            //     <div class="cards__flag-wrapper">
            //         <div class="cards__flag-type cards__flag-yellow">video</div>
            //         <div class="cards__flag-type">webinar</div>
            //     </div>
            //     <div class="cards__content no-gutters flex-column">
            //         <p class="cards__title">${title}</p>
            //         <p class="cards__subtitle truncate-lines-4">
            //             Learn how to find and solve vibration problems in piping systems. We'll show you new ways to
            //             identify
            //             vibratory
            //             service and examine the strengths of this test
            //         </p>
            //     </div>
            // </article>`;
            //     } else {
            //         return "";
            //     }
            // };
            img = img || `https://woodplc.com/?a=235271`;

            pageType = pageType ? pageType.replace(/\w*\s-\s/gm, "") : "";
            // console.log(pageType);
            if (pageType === "Webinar") {
                return `<a href="${url}" class="cards__card-wrapper cards__card-wrapper--video">
                <article class="cards__card row no-gutters flex-column justify-content-between flex-wrap">
                    <div class="cards__flag-wrapper">
                        <div class="cards__flag-type cards__flag-yellow">video</div>
                        <div class="cards__flag-type">webinar</div>
                    </div>
                    <div class="cards__image-wrapper">
                        <div class="cards__image"><img src="${img}" alt=""></div>
                    </div>
                    <div class="cards__content no-gutters flex-column justify-content-between">
                        <p class="cards__type">Webinar</p>
                        <div class="cards__title-wrapper">

                            <p class="cards__title">
                                ${title}
                            </p>
                        </div>
                    </div>
                </article>
                <article class="cards__card--hover cards__card row no-gutters flex-wrap">
                    <div class="cards__flag-wrapper">
                        <div class="cards__flag-type cards__flag-yellow">video</div>
                        <div class="cards__flag-type">webinar</div>
                    </div>
                    <div class="cards__content no-gutters flex-column">
                        <div class="cards__title-wrapper">

                            <p class="cards__title">${title}</p>
                        </div>
                        <p class="cards__subtitle truncate-lines-4">
                            ${description}
                        </p>
                    </div>
                </article>
            </a>`;
            } else {
                return ` <a href="${url}" class="cards__card-wrapper cards__card-wrapper">
                    <article class="cards__card row no-gutters flex-column justify-content-between flex-wrap">
                        <div class="cards__flag-wrapper">
                        ${
                            pageType === "Podcast"
                                ? '<div class="cards__flag-type cards__flag-yellow">audio</div>'
                                : ""
                        }
                        ${
                            pageType === "Webinar" || pageType === "Spotlight"
                                ? '<div class="cards__flag-type cards__flag-yellow">video</div>'
                                : ""
                        }
                            <div class="cards__flag-type">
                            ${pageType}
                            </div>
                        </div>
                        <div class="cards__image-wrapper">
                            <div class="cards__image"><img src="${img}" alt=""></div>
                        </div>
                        <div class="cards__content no-gutters flex-column justify-content-between">
                            <p class="cards__type">${pageType}</p>
                            <div class="cards__title-wrapper">
                            <p class="cards__title truncate-lines-2">
                               ${title}
                            </p>
                            </div>
                        </div>
                    </article>
                </a>`;
            }
        };

        /**
         * @param {[]} array array with items
         * @param {string} heading
         * @param viewAllURL
         * @returns {html}
         */
        const boxWrapperTemplate = (array) => {
            if (array.length) {
                let output = "";

                output += `<div class="insights-listing__wrapper insights-landing">
                    <div class="cards cards-story">
                        <div class="cards__wrapper col-mobile-centered">`;

                for (let i = 0; i < array.length; i++) {
                    // clickTrackingUrl, title, pageType, img, url, marks, date
                    output += boxTemplate(
                        array[i].clickTrackingUrl,
                        array[i].title,
                        array[i].pageType,
                        array[i].profileImage,
                        array[i].url,
                        array[i].marks,
                        array[i].date,
                        array[i].ewDescription
                    );
                }

                output += `</div></div></div>`;
                return output;
            }
        };
        await sortData();
        output += boxWrapperTemplate(searchInsightsListingRaw) || "";

        //removing old output after raload data
        var contntWrapper = document.querySelector(
            "results-wrapper--insights-listing"
        );
        if (contntWrapper) {
            contntWrapper.parentNode.removeChild(contntWrapper);
        }

        //displaing output on front
        document.querySelector(".results-wrapper").innerHTML = output;
    };

    if (document.querySelector(".fbjs-search--insights-listing")) {
        window.searchAZ = new Search.default({
            url: "https://dxp-uk-search.funnelback.squiz.cloud/s/search.json",
            collections: ["wood~sp-push-data"],
            additionalFBparams: {
                profile: "_default",
                gscope1: "insightsListing",
            },
            onFiltersUpdate: () => {
                buildHtml();

                const activeFilters =
                    window.searchArticles?.search.activeFacets;
                for (const entry in activeFilters) {
                    if (activeFilters[entry].value !== []) {
                        hasActiveFilters = true;
                        return hasActiveFilters;
                    }
                }
                searchInsightsListingData.aditionalInfo.resetData = 1;
            },
            beforeSearch: () => {
                //reset global data

                if (searchInsightsListingData.aditionalInfo.resetData) {
                    searchInsightsListingRaw = [];
                    searchInsightsListingData.viewpoint = null;
                    searchInsightsListingData.article = null;
                    searchInsightsListingData.podcast = null;
                    searchInsightsListingData.blog = null;
                    searchInsightsListingData.report = null;
                    searchInsightsListingData.aditionalInfo.resetData = 0;
                }
            },
            sort: {
                type: "date",
            },
            results: {
                numRanks: 30,
                startRank: 1,
            },
            activeFacetsOnStart: {
                "f.pageType|pageType": [],
                "f.keyMarketEnergy|keyMarketEnergy": [],
                "f.keyMarketEnvironment|keyMarketEnvironment": [],
                "f.geographies|geographies": [],
            },

            pagination: {
                loadMore: true,
            },

            templates: {
                activeFacet: (name, param) => {
                    const changeName = name
                        .replace(/_ampersand_/gi, "&")
                        .replace(/_comma_/gi, ",");
                    return `
                      <span param="${param}" name="${name}">
                        ${changeName}
                      </span>
                    `;
                },
                articleTemplate: (fields) => {
                    // x.push(fields); // for debeug funnelback data
                    buildHtml();
                    searchInsightsListingRaw.push({
                        type: fields.listMetadata.type?.[0] || "",
                        pageType: fields.listMetadata.pageType?.[0] || "",
                        clickTrackingUrl: fields.clickTrackingUrl || "",
                        summary: fields.summary?.[0] || "",
                        id: fields.listMetadata.id?.[0] || "",
                        title: fields.listMetadata.t?.[0] || "",
                        url: fields.displayUrl || "",
                        profileImage: fields.listMetadata.image?.[0] || "",
                        marks: fields?.listMetadata.marks,
                        date: fields.listMetadata.d?.[0] || "",
                        pageType: fields.listMetadata.pageType?.[0] || "",
                        ewSubtitle: fields.listMetadata.ewSubtitle?.[0] || "",
                        ewDescription: fields.listMetadata?.ewDescription?.[0] || "",
                        // "keyMarketEnergy": fields.listMetadata.keyMarketEnergy,
                        // "keyMarketEnvironment": fields.listMetadata.keyMarketEnvironment,
                        // "profileJobTitle": fields.listMetadata.profileJobTitle
                    });

                    return ``;
                },

                /**
                 * @name informationTemplate
                 * @param fields
                 * @param resultsSummary
                 * @param h
                 * @returns {string}
                 */
                informationTemplate: () => {
                    return "";
                },
                formTemplate: (search, query, inputId) => {
                    query == "!nullsearch" ? (query = "") : null;
                    // name="query"
                    // class="search-input-field"
                    return `
                    <div class="search-field">
                        <form class="search__form" role="search" action="/search" method="get">
                            <label for="${inputId}" class="sr-only">Search site</label>
                            <input
                                id="${inputId}"
                                type="text"
                                class="search__form-input search-custom"
                                placeholder="Insights search"
                                autocomplete="off"
                                role="searchbox"
                                aria-label="Search"
                                autocorrect="off"
                                autocapitalize="off"
                                spellcheck="false"
                                maxlength="1000"
                                aria-haspopup="menu"
                                aria-expanded="false"
                                value="${query}">
                            <button type="submit" name="site-search-submit" id="site-search-submit" class="search__submit">
                                <i class="search__submit-icon" aria-hidden="true"></i>
                                <span class="sr-only">Do search</span>
                            </button>
                            <div class="fb-search-wrapper"></div>
                        </form>
                    </div>
                    `;
                },
                loadMoreTemplate: () => {
                    return '<div class="landing-page__button-wrapper"><button id="search-loadmore" type="button" title="Load more results" class="btn btn--secondary">Load more</button></div>';
                },
                facetCheckbox: (
                    { categories, singleChoice },
                    activeFacets,
                    h
                ) => {
                    //{name, label}, activeFacets
                    // const header = label ? `<div>${label}</div>` : `<div>${name}</div>`;
                    let list = "";
                    list +=
                        '<li class="search__facet-item search__facet-item--all"></li>';

                    categories[0].values.forEach((item) => {
                        if (item.label !== "other") {
                            list += `<li class="search__facet-item">
                                    <label class="search__facet-label">
                                        <input
                                        class="search__facet-input"
                                        type="checkbox"
                                        ${item.checked}
                                        value="${item.data}"
                                        name="${item.label}"
                                        data-fparam="${h.queryStringParamName}"
                                        data-singlechoice="${singleChoice}"
                                        />
                                        <span class="search__facet-span">${item.label}</span>
                                    </label>
                                    </li>`;
                        }
                    });

                    return `<div class="checkbox-facet">
                            <ul class="search__facets">
                            ${list}
                            </ul>
                        </div>`;
                },

                /**
                 * @name paginationTemplate
                 * @param query
                 * @param spell
                 * @returns {string}
                 */
                noResults: () => {
                    // let spellSuggestion = "";
                    // if (spell.text) {
                    //     spellSuggestion = `<div>Did you mean: <a href="?${spell.url}">${spell.text}</a>?</div>`;
                    // }
                    if (hasActiveFilters) {
                        return `<div>There are no results matching your filter criteria</div>`;
                    } else {
                        return `<div>We're sorry, we couldn't find anything matching</div>`;
                    }
                },
            },
        });

        window.searchAZ.init();
    }
}
